/**
 * White Label Branding Configuration
 * 
 * This file centralizes all branding elements to support white labeling.
 * Modify this file to rebrand the application.
 */

const brandingConfig = {
  // Basic Information
  appName: "NextCab",
  companyName: "NextCab",
  slogan: "Für dich. Für die Stadt.", // White-Label: Slogan anpassen (erscheint z.B. im Login-Bereich)

  // Contact Information
  email: "info@nextcab.de",
  phone: "+49 176570 15 830",
  address: "Lieth 2d, 25336 Elmshorn",
  owner: "Resuan Afzal", // White-Label: Inhaber/Geschäftsführer anpassen (Pflicht für Impressum gemäß TMG § 5)
  website: "https://nextcab.de", // White-Label: Website-URL anpassen

  // Supervisory Authority (Aufsichtsbehörde für Personenbeförderung)
  // White-Label: An die örtliche Aufsichtsbehörde des Kunden anpassen!
  supervisoryAuthority: {
    name: "Kreis Pinneberg",
    department: "Fachdienst Straßenverkehr – Personenbeförderung",
    address: "Kurt-Wagener-Straße 11, 25337 Elmshorn",
  },

  // Data Protection Authority (Datenschutz-Aufsichtsbehörde)
  // White-Label: An das Bundesland des Kunden anpassen! (siehe BRANDING_VERBESSERUNGEN.md Abschnitt 6.4)
  dataProtectionAuthority: {
    name: "Unabhängiges Landeszentrum für Datenschutz Schleswig-Holstein (ULD)",
    address: "Holstenstraße 98, 24103 Kiel",
    phone: "0431 988-1200",
    website: "https://www.datenschutzzentrum.de",
  },

  // Legal Information
  copyright: `© ${new Date().getFullYear()} NextCab`,
  
  // Colors
  colors: {
    primary: "#FFDC00", // Taxi Yellow
    secondary: "#222222", // Dark Gray
    accent: "#FFC107", // Amber
    success: "#4CAF50", // Green
    error: "#F44336", // Red
    warning: "#FF9800", // Orange
    info: "#2196F3", // Blue
    background: "#FFFFFF", // White
    text: {
      primary: "#333333", // Near Black
      secondary: "#757575", // Medium Gray
      light: "#FFFFFF", // White
    }
  },
  
  // Logos and Images
  logos: {
    primary: "/assets/NextCab_Schriftzug.png", // Full logo
    icon: "/assets/NextCab_Fahrzeug.png", // Icon only
    favicon: "/favicon.ico",
    mobileLogo: "/assets/NextCab_Fahrzeug.png",
  },
  
  // UI Elements
  ui: {
    borderRadius: "4px",
    buttonStyle: "rounded", // 'rounded', 'square', 'pill'
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  
  // Features Config
  features: {
    enableReports: true,
    enableLiveMap: true,
    enableShiftPlanning: true,
  },
  
  // Social Media
  socialMedia: {
    facebook: "https://facebook.com/nextcab",
    twitter: "https://twitter.com/nextcab",
    instagram: "https://instagram.com/nextcab",
  },
};

export default brandingConfig;